// extracted by mini-css-extract-plugin
export default {"AppService":"AppService_AppService__DfKpt","AppService__wrap":"AppService_AppService__wrap__IOjoe"};